import React, {
  FC,
  ChangeEvent,
  useState,
  MouseEventHandler,
  ReactNode,
  LegacyRef,
  KeyboardEventHandler,
} from 'react';
import classNames from 'classnames';
import style from './input.style.module.scss';
import { AiFillInfoCircle } from 'react-icons/ai';
import Tooltip from '../Tooltip/Tooltip';
type Props = {
  id: string;
  type: 'text' | 'password';
  placeholder?: string;
  name: string;
  label?: string;
  isDropdown?: boolean;
  isDatepicker?: boolean;
  autocomplete?: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onKeyDown?: (e) => void;
  value: string;
  error: string;
  disabled?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  icon?: ReactNode;
  autoComplete?: string;
  infoText?: string;
  isSearch?: boolean;
  maxLength?: number;
  required?: boolean;
  isFocus?: boolean;
};
const Input: FC<Props> = ({
  id,
  type,
  placeholder,
  name,
  onChange,
  onBlur,
  onKeyDown,
  value,
  error,
  disabled,
  className,
  onClick,
  icon,
  label,
  autoComplete = 'off',
  isSearch = false,
  required = false,
  maxLength,
  infoText,
  isFocus,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  return (
    <div
      className={classNames(
        style['input__container'],
        { [style['input__container--has-value']]: !!value },
        { [style['input__container--error']]: !!error },
        { [`${className}`]: !!className }
      )}
      onClick={(event) => onClick && onClick(event)}
    >
      {label && (
        <>
          <label htmlFor={id}>
            {label != '' ? label : placeholder}
            {infoText && (
              <span>
                <Tooltip content={infoText}>
                  <AiFillInfoCircle
                    style={{ fill: '#FF53FF' }}
                    fill={'#FF53FF !important'}
                  />
                </Tooltip>
              </span>
            )}
            {required && (
              <span className={style['input__container--required']}>*</span>
            )}
          </label>
        </>
      )}
      <input
        id={id}
        className={`${value ? style['value'] : ''} ${
          isSearch ? style['search'] : ''
        }`}
        disabled={disabled}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        name={name}
        type={showPassword ? 'text' : type}
        value={value}
        maxLength={maxLength}
        autoFocus={isFocus}
      />

      {icon && <>{icon}</>}
      {error && <div className={style['input__error']}>{error}</div>}
    </div>
  );
};
export default Input;
